import { type Spring } from 'framer-motion';

export const SMOOTH_SPRING_NO_REBOUND_TRANSITION = {
  damping: 20,
  mass: 0.75,
  stiffness: 200,
  type: 'spring',
};

const FAST_SPRING_NO_REBOUND_TRANSITION = {
  duration: 0.1,
  ease: 'easeInOut',
};

export const SHOW_AND_HIDE_ANIMATION_VARIANTS = {
  hide: {
    opacity: 0,
    transition: FAST_SPRING_NO_REBOUND_TRANSITION,
    y: -8,
  },
  show: {
    opacity: 1,
    transition: SMOOTH_SPRING_NO_REBOUND_TRANSITION,
    y: 0,
  },
};

export const show = {
  opacity: 1,
};

export const hide = {
  opacity: 0,
};

export const fullHeight = {
  height: 'auto',
};

export const noHeight = {
  height: 0,
};

const springAnimationDamping = 30;

type AnimationSpeed = 'fast' | 'normal' | 'slow' | 'veryFast' | 'verySlow';

export const springAnimation: Record<AnimationSpeed, Spring> = {
  fast: {
    damping: springAnimationDamping,
    stiffness: 550,
    type: 'spring',
  },
  normal: {
    damping: springAnimationDamping,
    stiffness: 450,
    type: 'spring',
  },
  slow: {
    damping: springAnimationDamping,
    stiffness: 400,
    type: 'spring',
  },
  veryFast: {
    damping: springAnimationDamping,
    stiffness: 600,
    type: 'spring',
  },
  verySlow: {
    damping: springAnimationDamping,
    stiffness: 350,
    type: 'spring',
  },
};
